import { // Login User
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_FAILURE,
  // Logout User
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGOUT_FAILURE,
  // Emails
  ADD_EMAIL,
  ADD_EMAIL_SUCCESS,
  EMAIL_FAILURE
} from "./actionTypes"

// Login User
export const loginUser = credentials => ({
  type: LOGIN_USER,
  credentials
});

export const loginUserSuccess = credentials => ({
  type: LOGIN_USER_SUCCESS,
  credentials
});

export const loginFailure = error => ({
  type: LOGIN_FAILURE,
  error
});

// Logout User
export const logoutUser = () => ({
  type: LOGOUT_USER
});

export const logoutUserSuccess = () => ({
  type: LOGOUT_USER_SUCCESS
});

export const logoutFailure = error => ({
  type: LOGOUT_FAILURE,
  error
});

// Add Email
export const addEmail = details => ({
  type: ADD_EMAIL,
  details
});

export const addEmailSuccess = email => ({
  type: ADD_EMAIL_SUCCESS,
  email
});

export const emailFailure = error => ({
  type: EMAIL_FAILURE,
  error
});